import { render } from "./GlobalFeatures.vue?vue&type=template&id=55a26ce0"
import script from "./GlobalFeatures.vue?vue&type=script&lang=js"
export * from "./GlobalFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__